var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!_vm.noText)?_c('span',[_vm._v(_vm._s(_vm.text))]):_vm._e(),_vm._v(" "),_c('i',{staticClass:"fas fa-circle-notch fa-spin"})])}
var staticRenderFns = []

export { render, staticRenderFns }